import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {directoryView_template} from './directoryView_template';
import {articleAnalytics_template} from "./articleAnalytics_template";
import { articleReviewHistory_template } from "./articleReviewHistory_template";

declare var ko: any;

export class articlesView_template_new extends vnTemplate{

    public directoryView: directoryView_template;
    public articleAnalytics: articleAnalytics_template;
    protected articleReviewHistory: articleReviewHistory_template;

    protected getTemplateHtml(): string{

        return /* html */`
                <div class="ww-form w-form-article w-form-article-view">

                    <div class="form-msg is-scheduled" data-bind="visible: isScheduledRepublishActive">
                        <p class="icon i-scheduled">There is a scheduled republish for this article.  Changes to the article will not sync to the website until the schedule date is reached.</p>
                    </div>

                    <div class="w-form w-form-large ">

                        <div class="form-header">
                            <button data-bind="event: { click: onClickCancel }" class="btn icon border only-icon i-back" type="button"></button>
                        </div>

                        <div class="form-pagination">
                            <button class="btn icon i-article-regular" type="button" data-bind="event: { click: onClickTab.bind($data,'article') }, css: { 'is-activated' : selectedTab() == 'article'}"><span class="btn-text">Article</span></button>
                            <button class="btn icon i-performance" type="button" data-bind="event: { click: onClickTab.bind($data,'analytics') }, css: { 'is-activated' : selectedTab() == 'analytics', 'copyleaks' : plagiarismStatus() == 'Submitted'}"><span class="btn-text">Analytics</span></button>
                            <button class="btn icon i-feedback ai-hightlight" type="button" data-bind="visible: idTemplate() != 15 && idTemplate() != 16, event: { click: onClickTab.bind($data,'reviews') }, css: { 'is-activated' : selectedTab() == 'reviews', 'highlight' : hasNewFeedback() }"><span class="btn-text">Feedback</span></button>
                        </div>

                        <!-- ----------------- -->
                        <!-- Analytics         -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content " data-bind="css: { 'is-showing' : selectedTab() == 'analytics'}"><!-- .is-showing -->
                            ${this.articleAnalytics.getHtmlBuild()}
                        </div>

                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'reviews'}"><!-- .is-showing -->
                            ${this.articleReviewHistory.getHtmlBuild()}
                        </div>

                        <!-- ----------------- -->
                        <!-- Article          -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'article'}"><!-- .is-showing -->

                            <div class="w-form-body">

                                <div class="form-body full-width">
                                    <!-- ----------------- -->
                                    <!-- General Info      -->
                                    <!-- ----------------- -->
                                    <strong class="form-sub-title ">General Info</strong>

                                 </div>

                            </div>

                            <div class="w-form-body general-info">

                                <div class="form-body">

                                    <div class="form-group img featured-video">
                                        <label class="form-label" data-bind="text : featuredVideo() ? 'Featured Video' : 'Featured Image' "></label>
                                        <div class="w-video" id="featured-image" data-bind="visible: featuredImageUrl() != null, css: {'is-optimized': isFeaturedImageMobileOptimized()}">
                                            <span class="feature-video-title" data-bind="text : featuredVideo() ? featuredVideo().title : '' "></span>
                                                <div class="w-img-optimization">
                                                    <span class="icon i-mobile">Mobile Optimization Preview</span>
                                                    <div class="img-optimization-overlay"></div>
                                                    <div class="img-optimization-crop"></div>
                                                    <div class="img-optimization-overlay"></div>
                                                </div>
                                            <img data-bind="attr: { src: featuredImageUrl }"  alt="image not found" />
                                        </div>
                                     </div>


                                    <!--
                                    <div class="form-group img">
                                        <label class="form-label" data-bind="visible: thumbnailImageUrl() != null">Thumbnail Image</label>
                                        <div class="w-img thumb" id="thumbnail-image" data-bind="visible: thumbnailImageUrl() != null">
                                            <img data-bind="attr: { src: thumbnailImageUrl }"  alt="image not found" />
                                        </div>
                                     </div>
                                     -->
                                </div>

                                <div class="form-body">

                                    <div class="form-group">
                                            <span class="title" data-bind="text: title"></span>
                                     </div>

                                    <div class="form-group">
                                         <label for="template" class="form-label">Excerpt (max 150 char)</label>
                                         <span data-bind="html: excerpt"></span>
                                    </div>

                                    <div class="form-group permalink-block">
                                       <div>
                                        <label for="" class="form-label">Permalink</label>
                                        <span data-bind="text: permalink"> </span>
                                       </div>
                                       <div>
                                        <button class="input-checkbox permalink-button btn-form"
                                        id="isPermalinkHistory"
                                        data-bind="event: { click: onClickShowPermalinkHistoryModal }, css: { 'button-red': permalinkRedirects() && permalinkRedirects().length > 0}">
                                        <span class="permalink-history-changes-total"
                                                id="permalinkHistoryChangesTotal"
                                                data-bind="text: permalinkHistory() && permalinkHistory().length ? '(' + permalinkHistory().length + ')' : ''; " >
                                        </span>

                                        <span data-bind="html: permalinkHistory() && permalinkHistory().length > 0 ? '&nbsp;History |&nbsp;' : ''; "></span>
                                        <span class="permalink-redirects"
                                                id="permalinkRedirects"
                                                data-bind="text: permalinkRedirects() && permalinkRedirects().length ? ' Active Redirect: ' +  permalinkRedirects().length : ' No redirects found'; ">
                                        </span>
                                        </button>
                                       </div>
                                    </div>

                                   <div class="form-group row start">


                                        <!-- Pop-up Window -->


                                        <div data-bind="css: {'is-visible' : isPermalinkPopupShown()}" id="permalink-popup" class="w-lightbox light-theme">
                                            <div class="lightbox-content w-form" id="permalinkEditWarning">
                                                <div class="form-header warning-header">
                                                    <span class="form-title">Permalink History</span>
                                                    <button class="close-button icon i-close-2" data-bind="click: onClickClosePermalinkHistoryModal"></button>
                                                </div>
                                                <div class="form-body">
                                                    <div class="form-group">
                                                        <p>
                                                            <strong>Warning:</strong> Changing URLs can negatively impact performance if not handled carefully.
                                                            URLs should only be changed to correct errors, or after keyword research and analysis.
                                                            If a live article needs to have its URL changed more than once, please alert a Lead Editor or Content Manager so they can have a second redirected created by IT.
                                                        </p>
                                                    </div>
                                                    <div class="form-group">
                                                        <p>Permalink Changes</p>
                                                    </div>
                                                    <div class="form-group">
                                                        <table class="list-action">
                                                            <thead>
                                                                <tr>
                                                                    <th><span>Date Created</span></th>
                                                                    <th><span>Permalinks</span></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody data-bind="foreach: permalinkHistory()">
                                                                <tr>
                                                                    <td><span data-bind="text: $data.dateCreated"></span></td>
                                                                    <td><span data-bind="text: $data.newPermalink"></span></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div class="form-group">
                                                        <p>Redirects</p>
                                                    </div>
                                                    <div class="form-group">
                                                        <table class="list-action">
                                                            <thead>
                                                                <tr>
                                                                    <th><span>From</span></th>
                                                                    <th><span>Redirected To</span></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody data-bind="foreach: permalinkRedirects()">
                                                                <tr>
                                                                    <td><span data-bind="text: $data.oldPermalink"></span></td>
                                                                    <td><span data-bind="text: $data.newPermalink"></span></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group-group">

                                        <div class="form-group">
                                            <label for="enable-amp" class="form-label">Include In Directory</label>
                                            <span data-bind="text: includeInDirectory"></span>
                                        </div>

                                         <div class="form-group">
                                            <label for="" class="form-label">Display Poll</label>
                                            <span data-bind="text: displayPoll"></span>
                                        </div>

                                         <div class="form-group" data-bind="visible: idTemplate() == 2 || idTemplate() == 3 || idTemplate() == 7 || idTemplate() == 14">
                                            <label for="table-of-contents" class="form-label">Table of Contents</label>
                                            <span data-bind="text: isTableOfContents"></span>
                                        </div>

                                         <div class="form-group" data-bind="visible: idTemplate() != 16">
                                            <label for="sponsored-content" class="form-label" >Sponsored Disclaimer</label>
                                            <span data-bind="text: isSponsored"></span>
                                        </div>

                                         <div class="form-group" data-bind="visible: idTemplate() != 16">
                                            <label for="developing-story" class="form-label">Live Blogging</label>
                                            <span data-bind="text: isDevelopingStory"></span>
                                        </div>

                                        <div class="form-group" data-bind="visible: idTemplate() == 3">
                                            <label for="list-order" class="form-label">List Numbering</label>
                                            <span data-bind="text: listOrder"></span>
                                        </div>

                                    </div>

                                    <div class="form-group-group">






                                   </div>

                                   <div class="form-group-group">

                                        <div class="form-group" data-bind="visible: idTemplate() == 2 || idTemplate() == 3 || idTemplate() == 14">
                                            <label for="enable-amp" class="form-label">Featured Tag</label>
                                            <span data-bind="text: featuredTag"></span>
                                        </div>
                                        <!-- ko if: articlePagesSettings()['additionalCreditEnabled'] -->
                                            <div class="form-group" data-bind="">
                                                <label for="enable-amp" class="form-label">Additional Credit</label>
                                                <span data-bind="html: additionalCredit"></span>
                                            </div>
                                        <!-- /ko -->

<!--                                         <div class="form-group" data-bind="visible: idTemplate() == 2 || idTemplate() == 14">-->
<!--                                             <label for="template" class="form-label">File Widget Url</label>-->
<!--                                             <span data-bind="text: fileUrl"></span>                                  -->
<!--                                        </div>-->

                                    </div>

                                </div>
                            </div>

                            <!-- ----------------- -->
                            <!-- template option    -->
                            <!-- ----------------- -->

                            <div class="w-form-body cat">
                                <strong class="form-sub-title no-margin">Display Options</strong>

                                <div class="form-body">

                                    <span class="form-sub-cat-title">Layout</span>

                                    <div class="form-group">
                                        <label for="" class="form-label">Hide Featured Image</label>
                                        <span data-bind="text: isFeaturedImageHidden"></span>
                                    </div>
                                     <div class="form-group" data-bind="visible : permissions()['article_edit_config_ads'].read" >
                                        <label for="hide-ads" class="form-label">Hide Ads</label>
                                        <span data-bind="text: isAdHidden"></span>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">Hide Comment</label>
                                        <span data-bind="text: isCommentsDisabled"></span>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">Hide Read Next Footer</label>
                                        <span data-bind="text: isReadNextDisabled"></span>
                                    </div>
                                </div>

                                <div class="form-body">
                                    <span class="form-sub-cat-title">Auto Units</span>
                                    <div class="form-group">
                                        <label for="" class="form-label">Quick Shop Links</label>
                                        <span data-bind="text: isDisplayCardQuickLinksShown"></span>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">Table of contents</label>
                                        <span data-bind="text: isTableOfContents"></span>
                                    </div>
<!--                                    <span class="form-sub-cat-title">Miscellaneous</span>-->
<!--                                    <div class="form-group">               -->
<!--                                        <label for="enable-amp" class="form-label">AMP Disabled</label> -->
<!--                                        <span data-bind="text: isAmpDisabled"></span>  -->
<!--                                    </div>               -->
                                </div>

                            </div>

                            <!-- ----------------- -->
                            <!-- Categorization    -->
                            <!-- ----------------- -->

                            <div class="w-form-body cat">
                                <strong class="form-sub-title no-margin categorization">Categorization</strong>

                                <div class="form-body">
                                    <div class="form-group">
                                        <label for="" class="form-label">Main Category</label>
                                        <span data-bind="text: primaryCategory"></span>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">Categories</label>
                                        <ul data-bind="foreach: categories">
                                            <li><span data-bind="text: category.name"></span></li>
                                        </ul>
                                    </div>

                                    <!-- ko if: idTemplate() == 15 -->
                                    <div class="form-group">
                                        <label for="" class="form-label">Channel</label>
                                        <span data-bind="text: channelName() ? channelName() : 'None'"></span>
                                    </div>

                                    <div class="form-group" data-bind="if: idChannel()">
                                        <label for="" class="form-label">Playlists</label>
                                        <!-- ko if: playlists().length > 0 -->
                                            <ul data-bind="foreach: playlists">
                                                <li><span data-bind="text: name ? name : 'None'"></span></li>
                                            </ul>
                                        <!-- /ko -->
                                        <!-- ko if: playlists().length == 0 -->
                                            <span>None</span>
                                        <!-- /ko -->
                                    </div>
                                    <!-- /ko -->
                                </div>
                                <div class="form-body">
                                    <div class="form-group">
                                        <label for="" class="form-label">Main Tag</label>
                                        <span data-bind="visible: primaryTag(), text: primaryTagName()"></span>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">Tags</label>
                                        <ul data-bind="foreach: tags">
                                            <li><span data-bind="text: $data.tag.name + ' ' + $data.tag.formattedTagTypeAndDataset"></span></li>
                                        </ul>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">Tag Reviewed by this Article</label>
                                        <span data-bind="visible: reviewTag(), text: reviewTagName()"></span>
                                    </div>
                                </div>
                            </div>

                            <!-- ----------------- -->
                            <!-- PINNED TAG   -->
                            <!-- ----------------- -->

                            <div class="w-form-body cat" data-bind="visible: pinnedTags().length > 0 && idTemplate() != 15 && idTemplate() != 16">
                                <strong class="form-sub-title no-margin pinned-tags">[DEPRECATED] Pinned Tags</strong>

                                <div class="form-body">

                                    <div class="form-group">
                                        <label for="" class="form-label">Title</label>
                                        <span data-bind="text: pinnedTagTitle"></span>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label" >Position</label>
                                        <span data-bind="text: pinnedTagPosition" style="text-transform: capitalize;"></span>
                                    </div>

                                </div>

                                <div class="form-body" data-bind="visible: pinnedTags().length > 0">

                                    <div class="form-group">
                                        <label for="" class="form-label">Style</label>
                                        <span data-bind="text: pinnedTagStyle" style="text-transform: capitalize;"></span>
                                    </div>
                                    <div class="form-group" data-bind="visible: pinnedTagType">
                                        <label for="" class="form-label"> Tag Type</label>
                                        <span data-bind="text: pinnedTagType"></span>
                                    </div>
                                    <div class="form-group" data-bind="visible: pinnedTagTypeOption">
                                        <label for="" class="form-label">Spec Field</label>
                                        <span data-bind="text: pinnedTagTypeOption" style="text-transform: capitalize;"></span>
                                    </div>

                                    <div class="form-group">
                                        <label for="" class="form-label">Tags</label>
                                        <ul data-bind="foreach: pinnedTags">
                                            <li><span data-bind="text: $data.name + ' ' + $data.formattedTagTypeAndDataset"></span></li>
                                        </ul>
                                    </div>

                                </div>

                            </div>

                            <div class="w-form-body">

                                <div class="form-body">
                                    <!-- ----------------- -->
                                    <!-- SEO               -->
                                    <!-- ----------------- -->

                                    <strong class="form-sub-title search-engine">SEO</strong>


                                    <div class="form-group ">
                                        <label for="seoTitle" class="form-label">Title</label>
                                        <span data-bind="text : seoTitle"></span>
                                    </div>

                                    <div class="form-group ">
                                        <label for="seoDescription" class="form-label">Description (max 150 char)</label>
                                        <span data-bind="text : seoDescription"></span>
                                    </div>

                                    <div class="form-group ">
                                        <label class="form-label" for="idArticle" >Next Article</label>
                                        <span data-bind="text: nextArticle"></span>
                                    </div>

                                     <!--Video uploads-->
                                     <!--Video uploads-->

                                </div>


                                <div class="form-body">

                                    <!-- ----------------- -->
                                    <!-- SMO               -->
                                    <!-- ----------------- -->
                                    <div class="social-media">
                                        <strong class="form-sub-title social-media">Social Media</strong>

                                        <div class="form-group ">
                                            <label for="smoTitle" class="form-label">SMO Title</label>
                                             <span data-bind="text : smoTitle"></span>
                                        </div>

                                        <div class="form-group ">
                                            <label for="smoDescription" class="form-label">SMO Description (max 150 char)</label>
                                             <span data-bind="text : smoDescription"></span>
                                        </div>

                                        <div class="form-group">
                                            <label for="socialTagLine" class="form-label">Social Tagline</label>
                                            <span data-bind="text: socialTagLine"></span>
                                        </div>

                                        <div class="form-group img">
                                            <label for="alternateImage" class="form-label">Alternate Image</label>
                                            <div class="w-img" id="featured-image" data-bind="visible: alternateImageUrl() != null">
                                                <img data-bind="attr: { src: alternateImageUrl }"  alt="image not found" />
                                            </div>

                                        </div>
                                    </div>

                                </div>


                            </div>

                            <div class="w-form-body" data-bind="visible: idTemplate() == 5 || idTemplate() == 6 || idTemplate() == 8">
                               <strong class="form-sub-title buyers-guide" data-bind="visible: idTemplate() == 5">PRODUCT REVIEW</strong>
                               <strong class="form-sub-title buyers-guide" data-bind="visible: idTemplate() == 6">BUYERS GUIDE</strong>
                               <strong class="form-sub-title buyers-guide" data-bind="visible: idTemplate() == 8">COLLECTION</strong>
                               <div class="form-body" style="padding-top: 0;margin-top: -1rem">
                                    <!-- ----------------- -->
                                    <!-- Intro text        -->
                                    <!-- ----------------- -->

                                    <div class="form-group form-group-content" >
                                        <label for="article_intro" class="form-label"></label>
                                       <p data-bind="html: introText"></p>
                                    </div>
                                </div>
                                <div class="form-body">
                                <div class="form-group">
                                        <div class="w-img-article-list">
                                            <ul class="img-article-list" data-bind="foreach: reviewItems, attr: { 'data-content': (idTemplate() == 5? 'product-review' : (idTemplate() == 6 ? 'buyers-guide' : (idTemplate() == 8 ? 'collection' :'' ))) }" id="review-item-list">
                                                <li class="img-article-item" data-bind="attr: {id: $index }">

                                                    <div class="w-info">
                                                        <span class="label icon " data-bind="class: tagAwardClass, text: award ? award.name : ''"></span>
                                                        <div>
                                                            <span data-bind="text: ($index() + 1)" class="order"></span>
                                                            <span data-bind="text: tag.name" class="title"></span>
                                                        </div>
                                                    </div>
                                                    <div class="ratio-content">
                                                        <img data-bind="attr: { src: extraImages.length > 0 ? extraImages[0].url : '/assets/images/placeholder-product.png\' }"  alt="image not found" />
                                                    </div>
                                                </li>

                                            </ul>
                                        </div>
                                     </div>
                                </div>
                            </div>

                             <div class="w-form-body" data-bind="visible: idTemplate() != 15 && idTemplate() != 16">
                                <div class="form-body section-content full-width">
                                    <!-- ----------------- -->
                                    <!-- CONTENT          -->
                                    <!-- ----------------- -->
                                    <strong class="form-sub-title">Content</strong>

                                    <div class="form-group form-group-content">
                                    <p data-bind="html: content"></p>
                                   </div>


                                </div>
                            </div>

                            ${this.directoryView.getHtmlBuild()}

                            <div class="w-form-body" data-bind="visible: [2,3,5,6,7,9,10,11,12].includes(idTemplate())">
                                <div class="form-body form-section faq">
                                    <!-- ----------------- -->
                                    <!--FAQ                -->
                                    <!-- ----------------- -->
                                    <strong class="form-sub-title faq">FAQ</strong>

                                    <div class="form-group">
                                        <div class="w-list">
                                            <ul data-bind="foreach: faqs">
                                                <li>
                                                    <div class="item-header">

                                                        <div>
                                                        </div>
                                                    </div>
                                                    <strong data-bind="text: $data.question">Question</strong>
                                                    <p data-bind="html: $data.answer"></p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div><!-- end w-tabs-content -->

                    </div>

                     <!-- ----------------- -->
                     <!-- SIDE FORM         -->
                     <!-- ----------------- -->

                    <div class="w-form w-form-side">
                        <div class="form-header">
                            <a class="btn icon border only-icon i-link" data-bind="visible: !isSubContent(), event: { click: onClickViewOnSite}"></a>
                            <button data-bind="event: { click: onClickEdit   }, visible: isEditShown" class="btn icon light" type="button">Edit Article</button>
                        </div>
                        <div class="w-form-body">



                            <div class="form-body full-width">

                                <!-- -----------------      -->
                                <!-- Publishing Information -->
                                <!-- -----------------      -->

                                <div>

                                    <strong class="form-sub-title">Article Information</strong>

                                    <div class="form-group-group">
                                        <div class="form-group">
                                            <label for="" class="form-label">Type</label>
                                            <span data-bind="text: template"></span>
                                        </div>
                                        <div class="form-group">
                                            <label for="" class="form-label">template</label>
                                            <span data-bind="text: templateLayout"></span>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Article ID</label>
                                            <span data-bind="text: id"></span>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Original Publish</label>
                                            <span data-bind="text: datePublished"></span>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Display Date</label>
                                            <span data-bind="text: dateMostRecentPublishStatus"></span>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Created On</label>
                                            <span data-bind="text: dateCreated"></span>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Last Updated</label>
                                            <span data-bind="text: dateUpdated"></span>
                                        </div>
                                        <div class="form-group" style="flex:1 50%" data-bind="visible: segments().length > 0 ">
                                            <label for="idSegment" class="form-label">Segment</label>
                                            <span data-bind="text: segment"></span>
                                        </div>
                                        <div data-bind="hidden : !permissions()['article_edit_publishingControl'].read" class="form-group" style="flex:1 50%">
                                            <label class="form-label">Classification</label>
                                            <span data-bind="text: classification"></span>
                                        </div>
                                        <div class="form-group" style="flex:1 50%">
                                            <label for="template" class="form-label">Visibility</label>
                                            <span data-bind="text: displayConfiguration"></span>
                                        </div>
                                         <div class="form-group" data-bind="if: permissions()['article_edit_embargo'].read" style="flex:1 50%">
                                            <label for="enable-amp" class="form-label">Under Embargo</label>
                                            <span data-bind="text: (isUnderEmbargo() ? 'Yes' : 'No')"></span>
                                        </div>
                                    </div>

                                </div>

                                <!-- ----------------- -->
                                <!-- Status            -->
                                <!-- ----------------- -->


                                <div class="status">
                                    <strong class="form-sub-title">Status</strong>

                                    <div class="form-group row">
                                         <div>
                                            <label for="idStatus" class="form-label">Article Status</label>
                                            <span data-bind="text: status"><span>
                                         </div>
                                         <div>
                                            <label class="form-label">Last Article Status</label>
                                            <span data-bind="text: dateLastStatus"><span>
                                         </div>
                                    </div>

                                    <div class="form-group row no-border">
                                         <div>
                                            <label for="idPublishStatus" class="form-label">Publish Status</label>
                                            <span data-bind="text: publishStatus"><span>
                                         </div>
                                         <div>
                                            <label class="form-label">Last Publish Status</label>
                                            <span data-bind="text: datePublishStatus"><span>
                                         </div>
                                    </div>


                                   <div class="form-group row ">
                                         <div>
                                            <label for="" class="form-label">Sync Status</label>
                                             <span data-bind="text: syncStatus"></span>
                                         </div>
                                         <div>
                                            <label class="form-label">Last Sync</label>
                                            <span data-bind="text: dateSyncStatus"><span>
                                         </div>
                                    </div>


                                </div>


                                <!-- ----------------- -->
                                <!-- Contributors      -->
                                <!-- ----------------- -->

                                <div class="contributors">
                                    <strong class="form-sub-title">Contributors</strong>

                                    <div class="form-group ">
                                           <label for="authorName" class="form-label">Author</label>
                                           <span data-bind="text: author"></span>
                                    </div>

                                    <div class="form-group">
                                        <label for="authorName" class="form-label label-tooltips">Display Authors</label>
                                        <ul data-bind="foreach: displayAuthors">
                                            <li><span data-bind="text: valnet_user.fullName"></span></li>
                                        </ul>
                                    </div>

                                    <div class="form-group ">
                                            <label for="srEditorName" class="form-label">Segment Lead</label>
                                            <span data-bind="text: editor"></span>
                                    </div>


                                    <div class="form-group ">
                                            <label for="jrEditorName" class="form-label">Editor</label>
                                            <span data-bind="text: jrEditor"></span>
                                    </div>

                                    <div class="form-group ">
                                        <label for="ideatorName" class="form-label">Ideator</label>
                                        <span data-bind="text: ideator"></span>
                                    </div>
                                </div>


                                <!-- ----------------- -->
                                <!-- Categorization    -->
                                <!-- ----------------- -->
                                <div class="form-section cat">
                                    <strong class="form-sub-title">Categorization</strong>

                                    <div class="form-group">
                                        <label for="idPaymentCategory" class="form-label">Payment Category</label>
                                        <span data-bind="text: postPaymentCategory"></span>
                                    </div>

                                    <div class="form-group">
                                        <label for="idNetworkCategory" class="form-label">Network Category</label>
                                        <span data-bind="text: networkCategory"></span>
                                    </div>

                                    <div class="form-group">
                                        <label for="idContentType" class="form-label">Content Type</label>
                                        <span data-bind="text: contentType"></span>
                                    </div>

                                     <div class="form-group">
                                        <label for="idIntent" class="form-label">Intent</label>
                                        <span data-bind="text: intent"></span>
                                     </div>
                                </div>
                            </div>

                            <!-- ----------------- -->
                            <!-- Republish History -->
                            <!-- ----------------- -->

                            <div class="form-body full-width republish">

                                <strong class="form-sub-title highlight">Republish History <span data-bind="text:(republishesCount() > 0 ? '(' + republishesCount() + ')': '' )"></span></strong>

                                <div class="republish-history is-scheduled" data-bind="foreach: republishes">
                                    <div class="form-group form-group-header">
                                        <label class="form-label icon" data-bind="css : {'i-scheduled': publishStatus.id == 2}">Republish date</label>
                                        <span data-bind="text: dateRepublished"></span>
                                    </div>
                                    <div class="form-group-group border">

                                        <div class="form-group">
                                            <label class="form-label">Author</label>
                                            <span data-bind="if: author"><span data-bind="text: author.valnet_user.fullName"></span></span>
                                        </div>

                                        <div class="form-group">
                                            <label class="form-label">Segment Lead</label>
                                            <span data-bind="if: editor"><span data-bind="text: editor.valnet_user.fullName"></span></span>
                                        </div>

                                        <div class="form-group">
                                            <label class="form-label">Editor</label>
                                             <span data-bind="if: juniorEditor"><span data-bind="text: juniorEditor.valnet_user.fullName"></span></span>
                                        </div>

                                        <div class="form-group">
                                            <label class="form-label">Payment Category</label>
                                            <span data-bind="if: postPaymentCategory"><span data-bind="text: postPaymentCategory.name"></span></span>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>


                `;
    }

    protected initPartial(): void{
        this.articleAnalytics = new articleAnalytics_template('articleAnalytics', this.getTemplateViewModel(), this);
        this.directoryView = new directoryView_template("article_directoryView", this.getTemplateViewModel(), this.caller);
        this.articleReviewHistory = new articleReviewHistory_template('articleReviewHistory', this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{

        return "articlesView_template_new";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return{
              id: ko.observable("")
            , permalinkHistory: ko.observableArray([])
            , isPermalinkPopupShown: ko.observable(false)
            , permalinkRedirects: ko.observableArray([])
            , brand: ko.observable()
            , idTemplate: ko.observable()
            , idClassification: ko.observable()
            , idPublishStatus: ko.observable(null)
            , title: ko.observable("")
            , excerpt: ko.observable("")
            , displayConfiguration: ko.observable("Visible Everywhere")
            , isAdHidden: ko.observable("Disabled")
            , isDevelopingStory: ko.observable("false")
            , listOrder: ko.observable()
            , featuredTag : ko.observable(null)
            , isAmpDisabled: ko.observable("Enabled")
            , isUnderEmbargo: ko.observable(false)
            , includeInDirectory: ko.observable(null)
            , isTableOfContents: ko.observable('false')
            , isSponsored: ko.observable('false')
            , primaryCategory: ko.observableArray("")
            , primaryTag: ko.observable(null)
            , primaryTagName: ko.observable('')
            , reviewTag: ko.observable(null)
            , reviewTagName: ko.observable('')
            , fileUrl: ko.observable("")
            , seoTitle: ko.observable("")
            , seoDescription: ko.observable("")
            , smoTitle: ko.observable("")
            , smoDescription: ko.observable("")
            , nextArticle: ko.observable("")
            , dateUpdated: ko.observable("")
            , dateCreated: ko.observable("")
            , datePublished: ko.observable("")
            , dateMostRecentPublishStatus: ko.observable("")
            , status: ko.observable("")
            , dateLastStatus: ko.observable("")
            , publishStatus: ko.observable("")
            , datePublishStatus: ko.observable("")
            , syncStatus: ko.observable("")
            , dateSyncStatus: ko.observable("")
            , template: ko.observable("")
            , templateLayout: ko.observable(null)
            , classification: ko.observable("")
            , reference: ko.observable("")
            , author: ko.observable("")
            , editor: ko.observable("")
            , jrEditor: ko.observable("")
            , ideator: ko.observable("")
            , displayAuthors: ko.observableArray([])
            , targetAudience: ko.observable("")
            , intent: ko.observable("")
            , idContentType: ko.observable("")
            , contentType: ko.observable("")
            , segment: ko.observable("")
            , segments: ko.observable([])
            , networkCategory: ko.observable("")
            , postPaymentCategory: ko.observable("")
            , content: ko.observable("")
            , introText: ko.observable("")
            , reviewItems: ko.observableArray([])
            , permalink: ko.observable("")
            , displayPoll: ko.observable("None")
            , featuredImageUrl: ko.observable()
            , thumbnailImageUrl: ko.observable()
            , alternateImageUrl: ko.observable()
            , categories: ko.observableArray([])
            , tags: ko.observableArray([])
            , republishes: ko.observableArray([])
            , republishesCount: ko.observable(0)
            , faqs: ko.observableArray([])
            , isEditShown: ko.observable(false)
            , selectedTab: ko.observable('article','analytics')
            , idLoggedUser: ko.observable("")
            , isScheduledRepublishActive: ko.observable(false)
            , pinnedTagTitle: ko.observable()
            , pinnedTagPosition: ko.observable()
            , pinnedTagStyle: ko.observable()
            , pinnedTagType: ko.observable()
            , pinnedTagTypeOption: ko.observable()
            , pinnedTags: ko.observableArray([])
            , permissions: ko.observableArray(this.initPermissions(['article_edit_self', 'article_edit_brand', 'article_edit_publishingControl', 'article_edit_embargo', 'article_edit_config_ads']))
            , isFeaturedImageHidden: ko.observable(false)
            , isCommentsDisabled: ko.observable(false)
            , isReadNextDisabled: ko.observable(false)
            , isDisplayCardQuickLinksShown: ko.observable(false)
            , socialTagLine :  ko.observable("")
            , isSidebarHidden :  ko.observable(false)
            , isDisplayCardQuickLinksMobileShown :  ko.observable(false)
            , plagiarismStatus: ko.observable(null)
            , brandId: ko.observable(null)
            , featuredVideo: ko.observable(null)
            , isSubContent : ko.observable(false)
            , articleHistoricalReviewComments: ko.observable([])
            , authorPrompts: ko.observableArray([])
            , hasNewFeedback: ko.observable(false)
            , isFeaturedImageMobileOptimized: ko.observable(false)
            , idChannel: ko.observable(null)
            , channelName: ko.observable(null)
            , playlists: ko.observable([])
            , additionalCredit: ko.observable(null)
            , articlePagesSettings: ko.observableArray([])
            , onClickEdit: function (data){
                huit_neuf_this.onClickEdit(data.id());
            },
            onClickTab: function (value, data, event) {
                huit_neuf_this.onClickTab(value);
            },
            onClickCancel: function (data, event){
                huit_neuf_this.onClickCancel();
            }
            , onClickViewOnSite: function (data){
                huit_neuf_this.onClickViewOnSite(data);
            }
            , onClickViewOnSiteAMP: function (data){
                huit_neuf_this.onClickViewOnSiteAMP(data);
            },
            onClickClosePermalinkHistoryModal: function (data, event) {
                huit_neuf_this.onClickClosePermalinkHistoryModal(false);
            },
            onClickShowPermalinkHistoryModal: function (data, event) {
                huit_neuf_this.onClickShowPermalinkHistoryModal(true);
            },
        }
    }

    public onClickEdit(id){

        this.caller.editArticle(id);
    }

    protected onClickCancel(){

        this.caller.goBackToArticles();
    }

    protected onClickTab(tab){
        if(tab == "analytics"){
            this.caller.getArticleAnalytics();
            this.caller.getShortTermReport();
        }
        this.getTemplateViewModel().selectedTab(tab);

        if (tab == 'reviews') {
            let idArticle = this.getTemplateViewModel().id();
            if (idArticle) {
                this.caller.getSensaiArticleReferences("article_content", idArticle);
            }
        }
    }

    protected onClickViewOnSite(data){

        let brand = this.getTemplateViewModel().brand();

        if(this.getTemplateViewModel().idPublishStatus() == 1 || this.getTemplateViewModel().idPublishStatus() == 2){

            this.caller.previewArticle(data,brand);
        }else{

            this.caller.viewArticleOnSite(data,brand);
        }
        return false;
    }

    protected onClickViewOnSiteAMP(data){

        let brand = this.getTemplateViewModel().brand();

        if(this.getTemplateViewModel().idPublishStatus() == 1 || this.getTemplateViewModel().idPublishStatus() == 2){

            this.caller.previewArticleAMP(data,brand);
        }else{

            this.caller.viewArticleOnSiteAMP(data,brand);
        }
        return false;
    }

    public setId(id): void{

        this.getTemplateViewModel().id(id);
    }
    public getId(){

       return this.getTemplateViewModel().id();
    }

    public setArticleHistoricalReviewComments(articleHistoricalReviewComments){

        this.getTemplateViewModel().hasNewFeedback(false);
        //check if any feedback has been made in the last 48 hours
        for(let comment of articleHistoricalReviewComments){

            let date = new Date(comment.dateCreated.date);
            let current = new Date();
            let diff = Math.abs(current.getTime() - date.getTime());
            //let diffDays = Math.ceil(diff / (1000 * 3600 * 24));
            let diffHours = Math.ceil(diff / (1000 * 3600));
            if(diffHours <= 48){
                this.getTemplateViewModel().hasNewFeedback(true);
            }

        }
        this.getTemplateViewModel().articleHistoricalReviewComments(articleHistoricalReviewComments);
        this.articleReviewHistory.setReviewItems(articleHistoricalReviewComments);
        let prompt = this.getPromptToShow(3);
        if (prompt && typeof prompt === 'object' && 'agreement' in prompt) {
            this.articleReviewHistory.setGuidelines(prompt.agreement);
        }

    }

    public setBrand(brand): void{

        this.getTemplateViewModel().brand(brand)
    }

    public setBrandId(idBrand): void{

        this.getTemplateViewModel().brandId(idBrand)
    }

    public getBrandId(){
        return this.getTemplateViewModel().brandId();
    }

    public setIdTemplate(id): void{

        this.getTemplateViewModel().idTemplate(id);
    }

    public setTemplateLayout(templateLayout): void{

        this.getTemplateViewModel().templateLayout(templateLayout);
    }

    public setIdClassification(id): void{

        this.getTemplateViewModel().idClassification(id);
    }

    public setTitle(title): void{

        this.getTemplateViewModel().title(title);
    }

    public setReference(reference): void{

        this.getTemplateViewModel().reference(reference);
    }

    public setDatePublished(datePublished): void{

        this.getTemplateViewModel().datePublished(datePublished);
    }

    public setDateMostRecentPublishStatus(dateMostRecentPublishStatus): void{

        return this.getTemplateViewModel().dateMostRecentPublishStatus(dateMostRecentPublishStatus);
    }

    public getDatePublished(){

        return this.getTemplateViewModel().datePublished();
    }

    public setTargetAudience(targetAudience): void{

        this.getTemplateViewModel().targetAudience(targetAudience);
    }

    public setIntent(intent): void{

        this.getTemplateViewModel().intent(intent);
    }

    public setContentType(contentType): void{

        this.getTemplateViewModel().contentType(contentType);
    }

    public setIdContentType(idContentType): void{

        this.getTemplateViewModel().idContentType(idContentType);
    }

    public getIdContentType(){

        return this.getTemplateViewModel().idContentType();
    }

    public setAuthorPrompts(authorPrompts): void{

        this.getTemplateViewModel().authorPrompts(authorPrompts);

    }

    protected getPromptToShow(targetStatus): any {

        let promptData: any = false;

        let contentType = this.getTemplateViewModel().idContentType();
        let agreements = this.getTemplateViewModel().authorPrompts();

        if (agreements.hasOwnProperty(targetStatus)) {
            if (agreements[targetStatus].hasOwnProperty(contentType)) {
                promptData = agreements[targetStatus][contentType];
            } else if (agreements[targetStatus].hasOwnProperty('default')) {
                promptData = agreements[targetStatus]['default'];
            }
        }

        return promptData;
    }

    public setSegment(segment){
        this.getTemplateViewModel().segment(segment);
    }

    public setPermalink(permalink): void{

        this.getTemplateViewModel().permalink(permalink);
    }

    public setPermalinkHistory(permalinkHistory) {
        this.getTemplateViewModel().permalinkHistory(permalinkHistory);
    }

    public setPermalinkRedirect(permalinkRedirect){
        this.getTemplateViewModel().permalinkRedirects(permalinkRedirect);
    }

    public setDisplayPoll(displayPoll): void{

        this.getTemplateViewModel().displayPoll(displayPoll);
    }

    public setNetworkCategory(networkCategory): void{

        this.getTemplateViewModel().networkCategory(networkCategory);
    }

    public setPostPaymentCategory(postPaymentCategory): void{

        this.getTemplateViewModel().postPaymentCategory(postPaymentCategory);
    }

    public setArticleRepublishData(republishes){

        //filter to exclude non-reportable republish
        republishes = republishes.filter(republish => { return republish.isReportable == 1})

        //sort the array by date
        republishes.sort((a, b) => new Date(b.dateRepublished).valueOf() -  new Date(a.dateRepublished).valueOf());

        //find the one which schedule
        let index = republishes.findIndex(element => element.publishStatus.id == 2);

        if(index != -1){
            this.getTemplateViewModel().isScheduledRepublishActive(true);
        }

        this.getTemplateViewModel().republishes(republishes);
    }

    public setIsEditShown(isEditShown): void{

        this.getTemplateViewModel().isEditShown(isEditShown);
    }
    public setTopKeyWordAnalytics(response): void{
        this.articleAnalytics.setAnalytics(response);
    }
    public getTopKeyWordAnalytics(){
        return this.articleAnalytics.getAnalytics();
    }

    public setPermissions(permissions): void {

        this.getTemplateViewModel().permissions(permissions);
        this.articleAnalytics.setPermissions(permissions);
    }

    public setIdLoggedUser(idLoggedUser): void{

        this.getTemplateViewModel().idLoggedUser(idLoggedUser);
    }

    public setFeaturedImageUrl(featuredImageUrl): void{

        this.getTemplateViewModel().featuredImageUrl(featuredImageUrl)
    }

    public setThumbnailImageUrl(thumbnailImageUrl): void{

        this.getTemplateViewModel().thumbnailImageUrl(thumbnailImageUrl)
    }

    public setExcerpt(excerpt): void{

        this.getTemplateViewModel().excerpt(excerpt);
    }

    public setDisplayConfiguration(displayConfiguration): void{

        this.getTemplateViewModel().displayConfiguration(displayConfiguration);
    }

    public setIsAdHidden(isAdHidden): void{

        this.getTemplateViewModel().isAdHidden(isAdHidden);
    }

    public setIsDevelopingStory(isDevelopingStory): void{

        this.getTemplateViewModel().isDevelopingStory(isDevelopingStory);
    }

    public setListOrder(listOrder): void{

        this.getTemplateViewModel().listOrder(listOrder);
    }

    public setIsAmpDisabled(isAmpDisabled): void{

        this.getTemplateViewModel().isAmpDisabled(isAmpDisabled);
    }

    public setIsUnderEmbargo(isUnderEmbargo): void{

        this.getTemplateViewModel().isUnderEmbargo(isUnderEmbargo);
    }

    public setIncludeInDirectory(includeInDirectory): void{

        this.getTemplateViewModel().includeInDirectory(includeInDirectory);
    }
    public setIsTableOfContents(tableOfContents): void{

        this.getTemplateViewModel().isTableOfContents(tableOfContents);
    }

    public setIsSponsored(isSponsored): void{

        this.getTemplateViewModel().isSponsored(isSponsored);
    }

    public setFileUrl(url): void{

        this.getTemplateViewModel().fileUrl(url);
    }

    public setPrimaryCategory(primaryCategory): void{

        this.getTemplateViewModel().primaryCategory(primaryCategory);
    }

    public setPrimaryTag(primaryTag): void{
        if (primaryTag) {

            let primaryTagName = `${primaryTag.name} ${primaryTag.formattedTagTypeAndDataset}`;
            this.getTemplateViewModel().primaryTagName(primaryTagName);
        }
        this.getTemplateViewModel().primaryTag(primaryTag);
    }

    public setReviewTag(reviewTag): void{
        if (reviewTag) {

            let reviewTagName = `${reviewTag.name} ${reviewTag.formattedTagTypeAndDataset}`;
            this.getTemplateViewModel().reviewTagName(reviewTagName);
        }
        this.getTemplateViewModel().reviewTag(reviewTag);
    }

    public setSeoTitle(seoTitle): void{

        this.getTemplateViewModel().seoTitle(seoTitle);
    }

    public setSeoDescription(seoDescription): void{

        this.getTemplateViewModel().seoDescription(seoDescription);
    }

    public setSmoTitle(smoTitle): void{

        this.getTemplateViewModel().smoTitle(smoTitle);
    }

    public setSocialTagLine(socialTagLine): void{

        this.getTemplateViewModel().socialTagLine(socialTagLine);
    }

    public setSmoDescription(smoDescription): void{

        this.getTemplateViewModel().smoDescription(smoDescription);
    }

   public setNextArticle(nextArticle): void{

        this.getTemplateViewModel().nextArticle(nextArticle);
    }

    public setAlternateImage(alternateImage) : void{

        this.getTemplateViewModel().alternateImageUrl(alternateImage)
    }

    public setDateUpdated(dateUpdated): void{

        this.getTemplateViewModel().dateUpdated(dateUpdated);
    }

    public setDateCreated(dateCreated): void{

        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public setTemplate(template): void{

        this.getTemplateViewModel().template(template);
    }

    public setClassification(classification) : void{
        this.getTemplateViewModel().classification(classification)
    }

    public setStatus(status): void{

        this.getTemplateViewModel().status(status);
    }

    public setDateStatus(dateStatus): void{

        this.getTemplateViewModel().dateLastStatus(dateStatus);
    }

    public setDatePublishStatus(datePublishStatus): void{

        this.getTemplateViewModel().datePublishStatus(datePublishStatus);
    }

    public setLastSync(sync): void{

        this.getTemplateViewModel().syncStatus(sync);
    }

    public setDateLastSync(dateLastSync): void{

        this.getTemplateViewModel().dateSyncStatus(dateLastSync);
    }

    public setAuthor(author): void{

        this.getTemplateViewModel().author(author);
    }

    public setDisplayAuthors(displayAuthors): void{

        this.getTemplateViewModel().displayAuthors(displayAuthors);
    }

    public setEditor(editor): void{

        this.getTemplateViewModel().editor(editor);
    }

    public setJrEditor(jrEditor): void{

        this.getTemplateViewModel().jrEditor(jrEditor);
    }

    public setIdeator(ideator): void{
        this.getTemplateViewModel().ideator(ideator);
    }

    public setContent(content): void{

        this.getTemplateViewModel().content(content)
    }

    public setAdditionalCredit(additionalCredit): void{
        this.getTemplateViewModel().additionalCredit(additionalCredit);
    }

    public setCategories(categories): void{

        this.getTemplateViewModel().categories(categories);
    }

    public setTags(tags): void{

        this.getTemplateViewModel().tags(tags);
    }

    public setPublishStatus(publishStatus): void{

        this.getTemplateViewModel().publishStatus(publishStatus);
    }

    public setIdPublishStatus(idPublishStatus): void{

        this.getTemplateViewModel().idPublishStatus(idPublishStatus);
    }

    public setFaqs(faqs): void{

        this.getTemplateViewModel().faqs(faqs);
    }

    public setPinnedTagTitle(title){

        this.getTemplateViewModel().pinnedTagTitle(title)
    }

    public setPinnedTagPosition(position){

        this.getTemplateViewModel().pinnedTagPosition(position)
    }

    public setPinnedTagStyle(style){

        this.getTemplateViewModel().pinnedTagStyle(style)
    }

    public setPinnedTagTagType(type){

        this.getTemplateViewModel().pinnedTagType(type);
    }

    public setPinnedTagTypeOption(option){

        this.getTemplateViewModel().pinnedTagTypeOption(option)
    }

    public setPinnedTags(tags){

        this.getTemplateViewModel().pinnedTags(tags)
    }

    public setReviewItems(reviewItems): void{

        for(let i = 0; i < reviewItems.length; i++){
            reviewItems[i].tagAwardClass = reviewItems[i].award ? 'i-' + reviewItems[i].award.name.replace(' ', '-').toLowerCase() : "";
        }

        this.getTemplateViewModel().reviewItems(reviewItems);
    }

    public setFeaturedTag(featuredTagObj){
        if(featuredTagObj !==null){
            this.getTemplateViewModel().featuredTag(featuredTagObj.name);
        }else{
            this.getTemplateViewModel().featuredTag("None");
        }
    }

    public setIntroText(introText): void{

        this.getTemplateViewModel().introText(introText);
    }

    public setIsFeaturedImageHidden(isFeaturedImageHidden): void {

        this.getTemplateViewModel().isFeaturedImageHidden(isFeaturedImageHidden);
    }

    public setIsCommentsDisabled(isCommentsDisabled): void {

        this.getTemplateViewModel().isCommentsDisabled(isCommentsDisabled);
    }

    public setIsReadNextDisabled(isReadNextDisabled): void {

        this.getTemplateViewModel().isReadNextDisabled(isReadNextDisabled);
    }

    public setIsDisplayCardQuickLinksShown(isDisplayCardQuickLinksShown): void {

        this.getTemplateViewModel().isDisplayCardQuickLinksShown(isDisplayCardQuickLinksShown);
    }

    public setIsSidebarHidden(isSidebarHidden): void {

        this.getTemplateViewModel().isSidebarHidden(isSidebarHidden);
    }

    public setIsDisplayCardQuickLinksMobileShown(isDisplayCardQuickLinksMobileShown): void {

        this.getTemplateViewModel().isDisplayCardQuickLinksMobileShown(isDisplayCardQuickLinksMobileShown);
    }

    public setPlagiarismResults(plagiarismResults): void {

        this.articleAnalytics.setPlagiarismResults(plagiarismResults);
    }

    public setPlagiarismStatus(plagiarismStatus): void {

        //1: Not Submitted, 2: Pending Submission, 3: Submitted
        switch(plagiarismStatus){
            case 1:
                this.articleAnalytics.setPlagiarismStatus("Not Submitted");
                this.getTemplateViewModel().plagiarismStatus("Not Submitted");
                break;
            case 2:
                this.articleAnalytics.setPlagiarismStatus("Pending Submission");
                this.getTemplateViewModel().plagiarismStatus("Pending Submission");
                break;
            case 3:
                this.articleAnalytics.setPlagiarismStatus("Submitted");
                this.getTemplateViewModel().plagiarismStatus("Submitted");
                break;
        }

    }

    public setShortTermReport(response): void{

        this.articleAnalytics.setShortTermReport(response);
    }

    public getArticleAnalytics(){
        return this.articleAnalytics;
    }

    public getShortTermReport(){
        this.caller.getShortTermReport();
    }

    public editWatchlist(isAddToWatchlist){
        this.caller.editWatchlist(isAddToWatchlist);
    }

    public setIsOnWatchlist(isOnWatchlist){
        this.articleAnalytics.setIsOnWatchlist(isOnWatchlist);
    }

    public setWatchlistButtonEnabled(watchlistButtonEnabled){
        this.articleAnalytics.setWatchlistButtonEnabled(watchlistButtonEnabled);
    }


    public setFeaturedVideo(featuredVideo){
        this.getTemplateViewModel().featuredVideo(featuredVideo)
    }

    public getFeaturedVideo(){
        return this.getTemplateViewModel().featuredVideo()
    }

    public setIsSubContent(value : boolean){
        this.getTemplateViewModel().isSubContent(value)
    }

    public getIsSubContent() : boolean{
        return this.getTemplateViewModel().isSubContent()
    }

    public setSegments(segments : Array<object>){
        this.getTemplateViewModel().segments(segments)
    }

    public getSegments(){
        return this.getTemplateViewModel().segments()
    }

    public setIsFeaturedImageMobileOptimized(isFeaturedImageMobileOptimized): void {
        this.getTemplateViewModel().isFeaturedImageMobileOptimized(isFeaturedImageMobileOptimized);
    }

    public isFeaturedImageMobileOptimized() {
        return this.getTemplateViewModel().isFeaturedImageMobileOptimized();
    }

    public setSavedFeedbacksHistoryOptions(options): void {

        let nonCurrent = options.filter((option) => option.id != 0);
        this.articleReviewHistory.showDropdown((nonCurrent.length > 0));

        this.articleReviewHistory.setSavedFeedbacksHistoryOptions(options);


        let id = this.getTemplateViewModel().id();
        let uuid = this.getFeedbackHistoryOption();
        if (id && uuid != 0) {
            this.caller.filterFeedBackHistory(id, uuid);
        } else {

            this.caller.getSensaiResults("article_content", this.getTemplateViewModel().idContentType());
        }
    }
    public getFeedbackHistoryOption() {
        return this.articleReviewHistory.getFeedbackHistoryOption();
    }
    public showFeedbackTabLoading(): void {
        this.articleReviewHistory.showLoading();
    }


    public hideFeedbackTabLoading(): void {
        this.articleReviewHistory.hideLoading();
    }

    public onClickClosePermalinkHistoryModal(data) {
        this.getTemplateViewModel().isPermalinkPopupShown(false);
    }

    public onClickShowPermalinkHistoryModal(data) {
        this.getTemplateViewModel().isPermalinkPopupShown(true);
    }

    public setChannel(channel) {
        this.getTemplateViewModel().idChannel(channel.id);
        this.getTemplateViewModel().channelName(channel.name);
    }

    public setPlaylists(playlists) {
        this.getTemplateViewModel().playlists(playlists);
    }

    public setRepublishesCount(count:number) {
        this.getTemplateViewModel().republishesCount(count);
    }

    public setArticlePagesSettings(articlePagesSettings) {
        this.getTemplateViewModel().articlePagesSettings(articlePagesSettings);
    }
    public getArticlePagesSettings() {
        return this.getTemplateViewModel().articlePagesSettings();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/articlesView_template_new.ts